import React, { useEffect , useContext } from 'react';
import L from 'leaflet'
import "leaflet.vectorgrid"
import {Marker, Popup, useMap} from 'react-leaflet';
import { Context } from '../store/reducer';
import { Line } from "react-chartjs-2";

import m_rainfall_1 from '../assets/img/marker/weather/m_dam-suii_1.png';
import m_rainfall_2 from '../assets/img/marker/weather/m_dam-suii_2.png';
import m_rainfall_3 from '../assets/img/marker/weather/m_dam-suii_3.png';
import m_rainfall_4 from '../assets/img/marker/weather/m_dam-suii_4.png';
import m_rainfall_5 from '../assets/img/marker/weather/m_dam-suii_5.png';
import hanrei_tooltip from '../assets/img/hanrei_tooltip.png';
import icon_info from '../assets/img/icon_info.png';

/**
 * 36: 河川管理情報システム ダム日集計
 * @param options
 * @returns {null}
 * @constructor
 */
const Component = ({options}) => {

    const handleSpotData = (item, waterStorageAmount, waterLevel, inflowAmount, dischargeAmount) => {

        let ret = []

        ret.push(<dl className='dl-list is-modal-spot'><dt>データ種別</dt><dd>{item["station_type_label"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>事業所名</dt><dd>{item["office_name"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>データ所管</dt><dd>{item["department"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>水系名</dt><dd>{item["water_system_name"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>河川名</dt><dd>{item["river_name"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>観測所番号</dt><dd>{item["observatory_id"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>観測所名</dt><dd>{item["name"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>緯度</dt><dd>{item["lat"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>経度</dt><dd>{item["lng"]}</dd></dl>)
      
        ret.push(<dl className='dl-list is-modal-spot'><dt>貯水位[EL.m]</dt><dd>{waterLevel}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>流入量[m3/s]</dt><dd>{inflowAmount}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>放流量[m3/s]</dt><dd>{dischargeAmount}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>貯水量[千m3]</dt><dd>{waterStorageAmount}</dd></dl>)

        return ret
    }

    const map = useMap()
    const { state } = useContext(Context);


     
    return Object.keys(state["vis_36"].data).map((key, index) => {
        
        const item = state["vis_36"].data[key];
        
        let labels = [];

        let dam_value1_list = [];
        let dam_value6_list = [];
        let dam_value7_list = [];

        let dam_extra1_list = [];
        let dam_extra2_list = [];
        let dam_extra3_list = [];

        Object.keys(item.rain_list).map(key => {

            const rainData = item.rain_list[key];
            
            labels.push(rainData.datetime);
            
            // 貯水量[千m3](表への表示用)
            dam_value7_list.push(rainData.value1); //
            
            // 貯水率利水容量
            dam_value1_list.push(rainData.value2); //

            // 貯水率有効容量
            dam_value6_list.push(rainData.value3); //

            // 貯水位[EL.m](アイコンの判別、表への表示用)
            dam_extra1_list.push(rainData.value4); //
            // 流入量[m3/s](表への表示用)
            dam_extra2_list.push(rainData.value5); //
            // 放流量[m3/s](表への表示用)
            dam_extra3_list.push(rainData.value6); //
        })

        // 貯水位[EL.m]のスライダーの現在の値
        const currentTenMinutesValue = dam_extra1_list[state.timeIdx] ? dam_extra1_list[state.timeIdx] : 0;
        
        // 貯水位のスライダーの現在の値
        const waterLevel = currentTenMinutesValue;
        // 流入量のスライダーの現在の値
        const inflowAmount = dam_extra2_list[state.timeIdx] ? dam_extra2_list[state.timeIdx] : 0;
        // 放流量のスライダーの現在の値
        const dischargeAmount = dam_extra3_list[state.timeIdx] ? dam_extra3_list[state.timeIdx] : 0;
        // 貯水量のスライダーの現在の値
        const waterStorageAmount = dam_value7_list[state.timeIdx] ? dam_value7_list[state.timeIdx] : 0;


        /**
         * 判定対象の値が途中で存在しない場合に、存在する中で1番近い下位レベルのアイコンを表示する処理。
         * @param index
         * @returns {*}
         */
        const getProperIcon = (index) => {

            const iconList = [];
            iconList[0] = m_rainfall_2; //平常は常に存在する。
            iconList[1] = item.dam_fixed4 != "" ? m_rainfall_3 : null; //常時満水位が存在するか。
            iconList[2] = item.dam_fixed5 != "" ? m_rainfall_4 : null; //ただし書き操作開始水位が存在するか。
            iconList[3] = item.dam_fixed6 != "" ? m_rainfall_5 : null; //サーチャージ水位が存在するか。
            
            // レベルを順に下げていき、アイコンが設定されているものを返す。
            for (let i = 3; i >= 0; i--) {
             
                // 上のレベルは無関係なのでスキップ
                if (i > index) {
                    continue;
                }
                
                if (iconList[i]) {
                    return iconList[i];
                }
            }
        }
        
        
        // グレー
        let icon = m_rainfall_1
        
        if (currentTenMinutesValue === "**" 
          || currentTenMinutesValue === "--"
          || currentTenMinutesValue === "MM"
          || currentTenMinutesValue === "CC"
          || currentTenMinutesValue === "") {
            
            // 欠測: グレー
            icon = m_rainfall_1
        } else if (item.dam_fixed4 != "" && currentTenMinutesValue < item.dam_fixed4) {
            
            // 平常(常時満水位[EL.m] 未満): 白
            icon = getProperIcon(0);

        } else if (item.dam_fixed5 != "" && currentTenMinutesValue < item.dam_fixed5) {
            
            // ただし書き操作開始水位 未満: 青色
            icon = getProperIcon(1);
            
        } else if (item.dam_fixed6 != "" && currentTenMinutesValue < item.dam_fixed6) {
            
            // サーチャージ水位 未満:オレンジ
            icon = getProperIcon(2);

        } else if (item.dam_fixed6 != "" && currentTenMinutesValue >= item.dam_fixed6) {
           
            //  サーチャージ水位 以上:赤
            icon = getProperIcon(3);

        } else {

            // 判定すべき値が全てブランクの場合、平常とする
            icon = m_rainfall_2
        }

        // if (item["name"] === "御調ダム") {
        //     console.log("貯水位", currentTenMinutesValue)
        //     console.log("常時満水位[EL.m]", item.dam_fixed4)
        //     console.log("常時満水位[EL.m] != \"\"", (item.dam_fixed4 != ""))
        //     console.log("ただし書き操作開始水位", item.dam_fixed5)
        //     console.log("ただし書き操作開始水位 != \"\"", (item.dam_fixed5 != ""))
        //     console.log("サーチャージ水位", item.dam_fixed6)
        //     console.log("currentTenMinutesValue < item.dam_fixed4", (currentTenMinutesValue < item.dam_fixed4))
        //     console.log("item[\"name\"]", item["name"])
        //     console.log("icon", icon)
        // }
        
        const iconUrl = new L.Icon({
            iconUrl: icon,
            iconRetinaUrl: icon,
            iconSize: [35, 35],
            iconAnchor: [17, 23],
            popupAnchor: [0, -50]
        });
        

        return (
          <>
              <Marker
                position={[item.lat, item.lng]}
                icon={iconUrl}
              >
                  <Popup autoPan={false} minHeight={400} maxHeight={800} minWidth={600} closeOnClick>
                      
                      <div className={"modal-detail"}>
                      
                      {
                          handleSpotData(item, waterStorageAmount, waterLevel, inflowAmount, dischargeAmount)
                      }

                      <div className="p-graph">
                          <div className="p-graph__main">
                              
                      <Line
                        height={400}
                        width={500}
                        data={{
                            "labels": labels,
                            "datasets": [
                                {
                                    yAxisID: 'y',
                                    "myFixedData": false,
                                    "label": "貯水率利水容量",
                                    "data": dam_value1_list,
                                    "borderColor": "blue",
                                    "backgroundColor": "blue"
                                },
                                {
                                    yAxisID: 'y',
                                    "myFixedData": false,
                                    "label": "貯水率有効容量",
                                    "data": dam_value6_list,
                                    "borderColor": "green",
                                    "backgroundColor": "green"
                                },
                            ]
                        }}
                        options={{
                            // responsive: true,
                            maintainAspectRatio: true,
                            elements: {
                                point: {
                                    radius : function(context){
                                        return context.dataIndex === state.timeIdx ? 8 : 0
                                    },
                                }
                            },
                            scales: {
                                x: {
                                    ticks: {
                                        maxTicksLimit: 24, // 表示する最大ラベル数
                                        autoSkip: true // 全てのラベルを表示する場合はfalseに設定
                                    }
                                },

                                // ダム
                                y: {
                                    type: 'linear',
                                    display: true,
                                    position: 'left',
                                    max: 100,
                                    min: 0,
                                    title: {
                                        display: true,
                                        text: "%"
                                    }
                                },
                            }
                        }}
                        id="chart-key"
                      />

                      </div>

                          <div className="p-graph__hanrei">
                              <div>
                                  <a href="" className="modal-link __ttl" onClick={e => {e.preventDefault(); return false;}} style={
                                      {
                                      '--hover-before-background': `url(${icon_info})`,
                                      '--hover-after-background': `url(${hanrei_tooltip})`
                                      }
                                  }>凡例について</a>
                              </div>

                              <div className="p-graph-hanrei">
                                  <ul className="p-graph-hanrei__list">

                                      <li><span className="pgh-item pgh-chosuiritsurisui"></span><span className="pgh-txt">貯水率利水容量[%]</span></li>
                                      <li><span className="pgh-item pgh-chosuiritsuyuukou"></span><span className="pgh-txt">貯水率有効容量[%]</span></li>
                                      
                                  </ul>
                              </div>
                              
                          </div>
                      </div>
                      </div>
                  </Popup>
              </Marker>

          </>
        );
    })
}

export default Component
